module.exports = "/_next/static/images/4342db135be233b3950487073755f57b-blog1-xs.png";